import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { footwearMaterialColumns } from "../../FootwearMaterialMaster/data";
import { attrGroupLinkedTables } from "components/PimDashboard/data";
import { attrGrpAttrAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";

export const fabricCodeSearchColumn = {
	name: "Fabric Id",
	key: "fabric_id",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (item) => ({ name: item?.fabric_code, key: item?.fabric_code }),
	},
};
export const fwMaterialCodeSearchColumn = {
	name: "Material Id",
	key: "fw_material_code",
	input_type: inputTypes.SELECT.key,
	data_type: datatypes.STRING.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (item) => ({
			name: item?.[footwearMaterialColumns.fw_material_code.key],
			key: item?.[footwearMaterialColumns.fw_material_code.key],
		}),
	},
};
export const sourcingOptionCogsColumn = {
	name: "COGS",
	key: "cogs",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.NUMBER.key,
	editable: true,
};
export const sourcingOptionCogsRemarkColumn = {
	name: "COGS Remark",
	key: "cogs_remark",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.STRING.key,
	editable: true,
};
export const sourcingOnlyColorColumnKeys = [sourcingOptionCogsColumn.key, sourcingOptionCogsRemarkColumn.key];

const overlaySourcingColorColumn = (row) => {
	if (row?.key === sourcingOptionCogsColumn.key) return { ...row, ...sourcingOptionCogsColumn };
	if (row?.key === sourcingOptionCogsRemarkColumn.key) return { ...row, ...sourcingOptionCogsRemarkColumn };
	return row;
};

export const buildColorTableColumns = (allAttributes = [], attrGroupsWithAttr = {}) => {
	const byKey = new Map();

	Object.values(attrGroupsWithAttr || {}).forEach((grp) => {
		if (grp?.linked_table !== attrGroupLinkedTables.color.key) return;
		(grp[attrGrpAttrAssocObj] || []).forEach((attr) => {
			if (attr?.key) byKey.set(attr.key, attr);
		});
	});

	(allAttributes || []).forEach((attr) => {
		if (!attr?.key) return;
		if (attr.linked_table === attrGroupLinkedTables.color.key || sourcingOnlyColorColumnKeys.includes(attr.key)) {
			byKey.set(attr.key, attr);
		}
	});

	const cols = [...byKey.values()].map(overlaySourcingColorColumn);
	if (!cols.some((col) => col.key === sourcingOptionCogsColumn.key)) cols.push(sourcingOptionCogsColumn);
	if (!cols.some((col) => col.key === sourcingOptionCogsRemarkColumn.key)) cols.push(sourcingOptionCogsRemarkColumn);
	return cols;
};

export const getDesignerEditableColorColumns = (columns = []) =>
	(columns || []).filter((col) => !sourcingOnlyColorColumnKeys.includes(col?.key));
export const washCareColumn = {
	name: "Wash Care",
	key: "wash_care",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.STRING.key,
	editable: true,
	default_value: "",
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
};

export const finalMRPColumn = {
	name: "Final MRP",
	key: "final_mrp",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.NUMBER.key,
	editable: true,
	default_value: 0,
};
export const hsnCodeColumn = {
	name: "HSN Code",
	key: "hsn_code",
	input_type: inputTypes.ENTER.key,
	data_type: datatypes.STRING.key,
	editable: true,
	default_value: "",
};
